import React from 'react';

interface CircleProps {
  color?: string;
  bg?: 'primary' | 'secondary' | string;
  value: JSX.Element | string;
  size?: string;
  fontSize?: string;
}
const Circle = ({
  value,
  bg = 'primary',
  color = 'white',
  size = '2',
  fontSize = 'sm',
}: CircleProps) => {
  return (
    <div
      className={`flex w-5 h-5 bg-${bg} justify-center align-middle  text-center rounded-full text-${color}`}
    >
      <div className={`my-auto text-center h-auto text-${fontSize}`}>
        {value}
      </div>
    </div>
  );
};

export default Circle;
